
import Vue from "vue";
import { AuthService } from "@/services/auth-service";
import { UserConfigService } from "@/services/user-config-service";
import { Permissions } from "@/models/user-configs/permissions";
import { printLocalDateTime } from "../../utils/pretty-print";

export default Vue.extend({
	data(){
		return {
			AuthService,
			UserConfigService
		};
	},
	computed: {
		canEditUsers():boolean {
			if (!this.AuthService.wfUser){
				return false;
			}
			if (!this.AuthService.wfCompany){
				return false;
			}
			return this.AuthService.wfUser.ID == this.AuthService.wfCompany.OwnerID;
		},
		canEditCompany():boolean{
			return this.canEditUsers;
		},
		isSupport():boolean{
			return AuthService.isDevModeEnabled;
		},
		isOwner():boolean {
			return this.AuthService.wfCompany.OwnerID == this.AuthService.wfUser.ID;
		},
		isAdmin():boolean {
			return this.UserConfigService.hasCurrentUserPermission((permissions:Permissions):boolean=>{
				return permissions.IsAdmin;
			});
		},
		canEditDashboard():boolean{
			return this.UserConfigService.hasCurrentUserPermission((permissions:Permissions):boolean =>{
				return permissions.CanSeeDashboard;
			});
		},
		canEditProducts():boolean {
			return this.UserConfigService.hasCurrentUserPermission((permissions:Permissions):boolean =>{
				return permissions.ProductPermissions.hasWritePermissions();
			});
		},
		buildTime():string {
			let d = new Date(0);
			d.setMilliseconds(process.env.VUE_APP_BUILD_DATE);
			return printLocalDateTime(d);
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	},
});
